import React from 'react'
import { Navbar, RegisterComponent, Footer } from '../../components'

const Register = () => {
  return (
    <div>
      <Navbar />
      <RegisterComponent />
      <Footer />
    </div>
  )
}

export default Register
